import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Classes from './Pricing.module.css';
import { motion, AnimatePresence } from 'framer-motion';
import { useSelector } from 'react-redux';

const TickBlue = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>
)

const Pricing = () => {
  const sectionRef = useRef(null); // Reference to the section
  const navigate = useNavigate();

  const navigateToSignup = () => {
    navigate('/login', { state: { data: "toSignup" } });
  }

  return (
    <section id='pricing-section' ref={sectionRef} className={Classes.hero}>
      <div className={Classes.miniText} > Pricing </div>
      <h1 className={Classes.subheading}> Choose your Plan </h1>
      <p className={Classes.text} style={{ color: 'white' }} >
        One simple plan to streamline your privacy management and data protection.
      </p>

      <div className={Classes.boxesList} >
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{
            delay: 0,
            duration: 0.3,
          }}
        >
          <div className={Classes.boxWhite} >
            <h5 className={Classes.boxMiniTitle} >Monthly</h5>
            <h5 className={Classes.priceText} > $10 <span style={{ fontSize: '15px', fontWeight: '500' }} >/month</span> </h5>
            <div className={Classes.list} >
              <div className={Classes.listItem} >
                <div className={Classes.blueTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} >AI-Powered Data Tracking</h5>
              </div>
              <div className={Classes.listItem} >
                <div className={Classes.blueTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} >Automated Data Removal</h5>
              </div>
              <div className={Classes.listItem} >
                <div className={Classes.blueTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} >Real-Time Email Alerts</h5>
              </div>
              <div className={Classes.listItem} >
                <div className={Classes.blueTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} >Downloadable Reports</h5>
              </div>
              <div className={Classes.listItem} >
                <div className={Classes.blueTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} > Customizable Monitoring </h5>
              </div>
              <div className={Classes.listItem} >
                <div className={Classes.blueTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} > Basic Support </h5>
              </div>
            </div>
            <motion.div
              whileTap={{ scale: 0.97 }}
              whileHover={{ scale: 1.03 }}
              className={Classes.blueBtn} onClick={navigateToSignup} >
              <h4>Get started for free</h4>
            </motion.div>
            <h5 className={`${Classes.text2} ${Classes.center}`} >No credit card required</h5>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{
            delay: 0.1,
            duration: 0.3,
          }}
        >
          <div className={Classes.boxBlue} >
            <div className='flexAlign10' >
              <h5 className={Classes.boxMiniTitle} >Yearly</h5>
              <div className={Classes.saveTextBtn} > <h5>Save 15% by billing annually</h5> </div>
            </div>
            <h5 className={Classes.priceText} > $100 <span style={{ fontSize: '15px', fontWeight: '500' }} >/year</span> </h5>
            <div className={Classes.list} >
              <div className={Classes.listItem} >
                <div className={Classes.whiteTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} >AI-Powered Data Tracking</h5>
              </div>
              <div className={Classes.listItem} >
                <div className={Classes.whiteTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} >Automated Data Removal</h5>
              </div>
              <div className={Classes.listItem} >
                <div className={Classes.whiteTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} >Real-Time Email Alerts</h5>
              </div>
              <div className={Classes.listItem} >
                <div className={Classes.whiteTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} >Downloadable Reports</h5>
              </div>
              <div className={Classes.listItem} >
                <div className={Classes.whiteTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} > Customizable Monitoring </h5>
              </div>
              <div className={Classes.listItem} >
                <div className={Classes.whiteTick} >
                  <TickBlue height='12px' fill='white' />
                </div>
                <h5 className={Classes.text2} > Basic Support </h5>
              </div>
            </div>
            <motion.div
              whileTap={{ scale: 0.97 }}
              whileHover={{ scale: 1.03 }}
              className={Classes.whiteBtn} onClick={navigateToSignup} >
              <h4>Get started for free</h4>
            </motion.div>
            <h5 className={`${Classes.text2} ${Classes.center}`} >No credit card required</h5>
          </div>
        </motion.div>
      </div>

    </section >
  );
};

export default Pricing;
